var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.contextMenuDisplay
    ? _c(
        "div",
        {
          ref: "contextMenu",
          class: ["container-context-menu", _vm.contextMenuClass],
          style: _vm.styleCssToolTip,
        },
        _vm._l(_vm.contextMenuOptions, function (option, index) {
          return _c("div", {
            key: "option" + index,
            staticClass: "option",
            domProps: { innerHTML: _vm._s(option.label) },
            on: {
              click: function ($event) {
                return _vm.clickOption(option.name, $event)
              },
            },
          })
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }